import MessagesList from '@/views/MessagesList/index.vue'

const MessagesListRouter = {
  path: '/messages-list',
  name: 'MessagesList',
  component: MessagesList,
  props: (route) => ({
    secret: route.query.secret
  })
}

export default MessagesListRouter
